export default __webpack_public_path__ + "static/media/kul.d87d09bf.png";